<template>
  <n-modal class="card-record" :loading="$var('load')" @close="$emit('close')">
    <h2>
      Запись в журнале
      <span v-if="edit.records" style="float: right; font-size: .8rem"><n-button icon="trash" @click="remove" /></span>
    </h2>
    <div class="body">
      <div class="object">Проект: {{ project.title }}</div>
      <div>Дата: {{ $app.date.format(record.publishedAt) }}</div>
      <div>Статус: {{ utils.status(record.status) }}</div>
      <div>Автор: {{ record.author.fullName }}</div>
    </div>
    <br />
    <n-items>
      <n-datepicker title="Дата" v-bind="$form.input('date')" inline :text="!edit.records" />
      <n-input title="Время, ч. (мин.)" v-bind="$form.input('time')" :text="!edit.records" />
      <n-input title="Интервал времени между отчетами ΔT, мин." v-bind="$form.input('interval1')" :text="!edit.records" />
      <n-input title="Нагрузка, кН: Общая" v-bind="$form.input('weight1')" :text="!edit.records" />
      <n-input title="Нагрузка, кН: для эталонной сваи или сваи-зонда: под нижним концом сваи" v-bind="$form.input('weight2')" :text="!edit.records" />
      <n-input title="Нагрузка, кН: для эталонной сваи или сваи-зонда: на боковой поверхности сваи" v-bind="$form.input('weight3')" :text="!edit.records" />
      <n-input title="Отсчеты по приборам, мм: по первому S1" v-bind="$form.input('counter1')" :text="!edit.records" />
      <n-input title="Отсчеты по приборам, мм: по второму S2" v-bind="$form.input('counter2')" :text="!edit.records" />
      <n-input title="Отсчеты по приборам, мм: Sn" v-bind="$form.input('counter3')" :text="!edit.records" />
      <n-input title="Перемещение мм" v-bind="$form.input('move')" :text="!edit.records" />
      <n-input title="Приращение перемещений ΔS, мм" v-bind="$form.input('movePrirash')" :text="!edit.records" />
      <n-input title="Сумма перемещений ΣS, мм" v-bind="$form.input('moveSum')" :text="!edit.records" />
      <n-input title="Суммарное время ΣT, мин" v-bind="$form.input('timeSum')" :text="!edit.records" />
      <n-input title="Примечание" v-bind="$form.input('remark')" :text="!edit.records" />
    </n-items>
    <br />
    <n-divide>
      <n-button v-if="edit.records" color="success" @click="save()">Сохранить</n-button>
      <n-button @click="$emit('close')">Закрыть</n-button>
    </n-divide>
  </n-modal>
</template>

<script>
import utils from 'utils'
import CModalJournalDoSign from 'components/journal/ModalDoSign'

export default {
  name: 'ModalRecord',
  components: { CModalJournalDoSign, },
  props: [ 'project', 'journal', ],
  data() {
    return {
      utils,
      record: { author: {}, },
      user: $app.auth.user(),
      tabs: [
        { name: 'info', title: 'Информация', callback: this.save, },
        { name: 'control', title: 'Проверяющие', },
      ],
      columns: [
        { title: 'Название', name: 'title', },
        { title: 'Расход', name: 'done', },
      ],
      translates: {
        attach: 'Приложения',
        schema: 'Исполнительные схемы',
        figure: 'Чертежи',
        input: 'Документы',
      },
    }
  },
  computed: {
    id() {
      return this.$route.query.show
    },
    edit() {
      return {
        records: this.record.status === 'waiting' && $app.auth.can('journals_'+this.journal.name+'_records', this.project.id),
      }
    },
  },
  watch: {
    '$route.query.id'() {
      this.load()
    },
  },
  created() {
    this.load()
    this.$form.init({})
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, this.journal.name, this.id).query({
        'with[author][with][participation]': null,
        'with[signs][with][author]': null,
        projectId: this.project.id,
      }).then((result) => {
        this.record = result.data.content
        this.$form.init(this.record)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    remove() {
      this.$var('load', true)
      $api.journals.records.remove(this.journal.name, this.record.id).then(() => {
        this.load()
        this.$emit('close')
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    accept(name, sign) {
      // this.$var('load', true)
      // $api.journals.spec59.records.accept(this.record.id, { name, sign, }).then((result) => {
      //   this.load()
      //   this.$emit('reload')
      // }).finally(() => {
      //   this.$var('load', false)
      // })
    },
    save() {
      this.$var('load', true)
      $api.journals.spec60.edit(this.record.id, this.$form.get()).then(() => {
        this.load()
      }).finally(() => {
        this.$var('load', false)
      })
    },
    checkIfSignIsExist(userId, signName) {
      let isExist = false
      if (this.record) {
        if (this.record.signs) {
          $n.each(this.record.signs, (el) => {
            if (el.authorId !== null || el.isApproved) {
              if (el.name === signName && el.authorId === userId && el.isApproved) {
                isExist = true
              }
            }
          })
        }
      }
      return isExist
    },
  },
}
</script>

<style lang="scss" scoped>
.card-record {
  
  .weather {
    .env, .temperature, .wind {
      width: 150px;
      margin-right: 20px;
    }
  }
  

}
</style>
